import React from 'react';
import palette from '../../lib/styles/palette';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const AdminClubCoupon = ({
    selectClubInfo,
    setCouponFlag,
    setCouponPeriod,
    setCouponRepeatCount,
    setCouponEditCount,
    setCouponAdd,
    setChangeInfo,
}) => {
    const onChangeCouponFlag = (e)=>{
        setCouponFlag(parseInt(e.target.value))
    }
  return selectClubInfo ? (
    <SettingCard title="쿠폰">
        <SettingInfoBox>
            <SettingInfoLabel>활성화 유무</SettingInfoLabel>
            <SettingInfoValue>
                <RadioGroup
                    aria-label="type"
                    name="viewType"
                    value={selectClubInfo.couponFlag}
                    onChange={onChangeCouponFlag}
                    row={true}
                >
                    <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="활성화"
                    />
                    <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="비활성화"
                    />
                </RadioGroup>
            </SettingInfoValue>
        </SettingInfoBox>
        {
            selectClubInfo.couponFlag == 1?
            <>
            <div style={{display:'flex', flexWrap:'wrap', alignItems:'center', margin:'4px 0 20px', padding:'12px 16px', background:'#f8f9fb', border:'1px solid #e0e4ea', borderRadius:'8px', fontSize:'0.92rem', fontWeight:'600', color:'#555', lineHeight:'1.5'}}>! 큐노스가 클럽에게 지급한 [<div style={{color:'#e74c3c'}}>미개봉 쿠폰</div>]{'은 매월 말일에 '}<div style={{paddingLeft:'2px', color:'#e74c3c'}}>{' 자동으로 소멸'}</div>{'되고 매월 1일에 '}<div style={{paddingLeft:'2px', color:'#e74c3c'}}>{' 자동으로 충전'}</div>된다.</div>
                <SettingInfoBox>
                    <SettingInfoLabel>쿠폰 유효기간</SettingInfoLabel>
                    <SettingInfoValue>
                        <div style={{display:'flex', alignItems: 'center'}}>
                            <div style={{width:'200px', padding:'0 10px 0 0'}}>(회원이 수령한 이후)</div>
                            <div style={{width:'100px'}}>
                                <input
                                    value={selectClubInfo.couponPeriod}
                                    onChange={(e) => setCouponPeriod(e.target.value)}
                                    style={{width: '100px', border: '1px solid #ccc', borderRadius: '6px', padding: '12px 16px', fontSize: '.95rem'}} type="text"
                                />
                            </div>
                            <div style={{padding:'0 0 0 10px'}}>달</div>
                        </div>
                    </SettingInfoValue>
                </SettingInfoBox>
                <SettingInfoBox>
                    <SettingInfoLabel>자동 충전 갯수</SettingInfoLabel>
                    <SettingInfoValue>
                        <div style={{display:'flex', alignItems: 'center'}}>
                            <div style={{width:'100px'}}>
                                <input
                                    value={selectClubInfo.couponRepeatCount}
                                    onChange={(e) => setCouponRepeatCount(e.target.value)}
                                    style={{width: '100px', border: '1px solid #ccc', borderRadius: '6px', padding: '12px 16px', fontSize: '.95rem'}} type="text"
                                />
                            </div>
                            <div style={{padding:'0 20px 0 10px'}}>개</div><div>(큐노스가 클럽에게)</div>
                        </div>
                    </SettingInfoValue>
                </SettingInfoBox>
                <SettingInfoBox>
                    <SettingInfoLabel>쿠폰 즉시 발급</SettingInfoLabel>
                    <SettingInfoValue>
                        <div style={{width:'100px'}}>
                            <input
                                value={selectClubInfo.couponEditCount}
                                onChange={(e) => setCouponEditCount(e.target.value)}
                                style={{width: '100px', border: '1px solid #ccc', borderRadius: '6px', padding: '12px 16px', fontSize: '.95rem'}} type="text"
                            />
                        </div>
                        <button
                            onClick={() => setCouponAdd()}
                            style={{backgroundColor: selectClubInfo.couponEditCount > 0?palette.webCyan[5]:'#fff', color:selectClubInfo.couponEditCount > 0?'#fff':'#E1E1E1', border: '1px solid rgba(0, 0, 0, .2)', borderRadius: '6px', padding: '4px 16px', cursor: 'pointer', margin:'0 0 0 10px'}}
                        >
                            즉시 발급
                        </button>
                        <div style={{padding:'0 0 0 20px'}}>(큐노스가 클럽에게)</div>
                    </SettingInfoValue>
                </SettingInfoBox>
                <SettingInfoBox>
                    <SettingInfoLabel>미사용 쿠폰</SettingInfoLabel>
                    <SettingInfoValue>
                        <div style={{width:'150px', padding:'0 10px 0 0'}}>{selectClubInfo.couponCount}장</div>
                    </SettingInfoValue>
                </SettingInfoBox>
            </>
            :null
        }
        <CardFooter>
            <SaveButton active={selectClubInfo.isEdit} onClick={() => setChangeInfo()}>
                수정하기
            </SaveButton>
        </CardFooter>
    </SettingCard>
  ) : null;
};

export default React.memo(AdminClubCoupon);
